import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileInvoice,
  faUsers,
  
  faShieldAlt,
  faChartLine,
  faCalculator,
  faChalkboardTeacher,
  faUserShield,
  faBalanceScale,
  faUserTie,
  faLeaf,
  faChartPie,

  faMoneyCheckAlt,
  faSearchDollar,
  faClipboardCheck,
  faBullseye,
  faProjectDiagram,
} from "@fortawesome/free-solid-svg-icons";


const ItemsSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("items-section");
      if (section) {
        const rect = section.getBoundingClientRect();
        setIsVisible(rect.top < window.innerHeight * 0.9 && rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const services = [
    {
      category: "Créateurs et repreneurs",
      items: [
        { icon: faFileInvoice, text: "Accompagnement à la création" },
        { icon: faBullseye, text: "Prévisionnel et business plan" },
        { icon: faSearchDollar, text: "Recherche de financement" },
        { icon: faProjectDiagram, text: "Conseil et Assistance d'entreprise" },
        { icon: faClipboardCheck, text: "Audit d'acquisition" },
      ],
    },
    {
      category: "Entrepreneurs et professionnels",
      items: [
        { icon: faChartLine, text: "Comptabilité et fiscalité" }, // Graphique = Comptabilité & Fiscalité
        { icon: faUsers, text: "Gestion Sociale et Paie" }, // Groupe de personnes = Gestion sociale et paie
        { icon: faBalanceScale, text: "Conseil juridique" }, // Balance = Droit et conseils juridiques
        { icon: faUserTie, text: "Conseil en gestion et pilotage" }, // Businessman = Gestion & Pilotage
        { icon: faChalkboardTeacher, text: "Formation" }, // Professeur = Formation
        { icon: faShieldAlt, text: "Solutions digitales" } // Bouclier = Sécurité et solutions digitales
      ],
    },
    {
      category: "PME, ETI et Grandes Entreprises",
      items: [
        { icon: faMoneyCheckAlt, text: "Comptabilité et corporate finance" }, // Calculatrice = Comptabilité
        { icon: faChartLine, text: "Conseil et Stratégie d'entreprise" }, // Graphique = Stratégie
        { icon: faChartPie, text: "Contrôle de gestion" }, // Graphique = Contrôle de gestion
        { icon: faCalculator, text: "Consolidation des comptes" }, // Calculatrice = Consolidation
        { icon: faUserShield, text: "Gestion du patrimoine" }, // Bouclier = Protection du patrimoine
        { icon: faLeaf, text: "RSE et développement durable" }, // Feuille = Développement durable
        { icon: faUsers, text: "Sécurité Humaine et Technologique" } // Personnes = Sécurité humaine
      ],
    },
  ];

  return (
    <Section id="items-section" className={isVisible ? "visible" : ""}>
      <CaricatureTopLeft
        src="/assets/images/caricature1.png"
        alt="Caricature en haut à gauche"
      />

      <CardsContainer>
        {services.map((service, index) => (
          <Card key={index} style={{ animationDelay: `${index * 0.2}s` }}>
            <h3>{service.category}</h3>
            {service.items.map((item, idx) => (
              <ServiceItem key={idx}>
                <FontAwesomeIcon icon={item.icon} className="service-icon" />
                {item.text}
              </ServiceItem>
            ))}
          </Card>
        ))}
      </CardsContainer>

      <CaricatureBottomRight
        src="/assets/images/caricature2.png"
        alt="Caricature en bas à droite"
      />
    </Section>
  );
};


const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;


const float = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const Section = styled.section`
  padding: 60px 20px;
  background: #fff;
  text-align: center;
  justify-content: center;
  position: relative;
  opacity: 0;
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  
  &.visible {
    opacity: 1;
    animation: ${fadeInUp} 1s ease-in-out;
  }

  h2 {
    color: #dc3545;
    font-size: 2.5rem;
    margin-bottom: 30px;
    position: relative;
    z-index: 2;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
`;

const Card = styled.div`
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  width: 350px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: 0.3s ease-in-out;
  opacity: 0;
  transform: translateY(30px);
  animation: ${fadeInUp} 0.6s ease-in-out forwards;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  h3 {
    color: #333;
    margin-bottom: 15px;
  }
`;

const ServiceItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #555;
  margin-bottom: 10px;

  .service-icon {
    color: #dc3545;
    margin-right: 10px;
    transition: 0.3s;

    &:hover {
      color: #28a745;
    }
  }
`;

const CaricatureTopLeft = styled.img`
  position: absolute;
  top: 15px;
  left: 15px;
  width: 80px;
  height: auto;
  opacity: 0.9;
  animation: ${float} 4s ease-in-out infinite;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 60px;
    top: 10px;
    left: 10px;
  }
`;

const CaricatureBottomRight = styled.img`
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 80px;
  height: auto;
  opacity: 0.9;
  animation: ${float} 4s ease-in-out infinite;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 60px;
    bottom: 5px;
    right: 5px;
  }
`;

export default ItemsSection;
